export default "__VITE_ASSET__2f7SjMdS__"